import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AccountPaymentMethod, PaymentStatus } from '../../../models';
import { CustomerPayment } from '../../../models/payment-document.model';
import { AutopayEnrollmentBannerVariant } from '../../autopay-enrollment-banner/autopay-enrollment-banner.component';

@Component({
  selector: 'payment-summary-header',
  templateUrl: './payment-summary-header.component.html',
  styleUrls: ['./payment-summary-header.component.scss'],
})
export class PaymentSummaryHeaderComponent {
  @Input() customerPayment: CustomerPayment;
  @Input() hasMultipleTransactions: boolean;
  @Input() transactionBuyerAccounts: string[];
  @Input() transactionsTotal: number;
  @Input() transactionsSubTotal: number;
  @Input() transactionsCreditTotal: number;
  @Input() isDiscountAmountVisible: boolean;
  @Input() transactionsAppliedDiscountTotal: number;
  @Input() transactionsSurchargeTotal: number;
  @Input() surchargePercentage: number;
  @Input() isAutopaySupported: boolean;
  @Input() isAutopayEnabled: boolean;
  @Input() isSurchargeFeeVisible: boolean;
  @Input() isSurchargeFeePercentageVisible: boolean;
  @Input() showAutopayEnrollmentBanner: boolean;
  @Input() autopayBannerVariant: AutopayEnrollmentBannerVariant = 'domestic';
  @Output() enrollInAutopayClicked = new EventEmitter<void>();

  paymentStatus = PaymentStatus;

  get approvedHeaderKey(): string {
    if (!this.hasMultipleTransactions) {
      return this.notScheduled()
        ? 'ARC_PAYMENT_SUMMARY_HEADER_PAYMENT_APPROVED'
        : 'ARC_PAYMENT_SUMMARY_HEADER_PAYMENT_SCHEDULED';
    }
    return this.notScheduled()
      ? 'ARC_PAYMENT_SUMMARY_HEADER_PAYMENTS_APPROVED'
      : 'ARC_PAYMENT_SUMMARY_HEADER_PAYMENTS_SCHEDULED';
  }

  private notScheduled() {
    return (
      this.customerPayment.paymentType === AccountPaymentMethod.Card &&
      !this.customerPayment.isScheduledPayment
    );
  }
}
